(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3ScoreDifferentialModal', {
            templateUrl: 'app/shared/score-history/score-differential-modal.component.html',
            controller: ScoreDifferentialModalComponent,
            bindings: {
                close: '&',
                resolve: '<'
            }
        });

    ScoreDifferentialModalComponent.$inject = [];
    function ScoreDifferentialModalComponent() {
        var ctrl = this,
            scaleType = 0;
        ctrl.$onInit = init;

        function init() {
            ctrl.score = ctrl.resolve.score;            
        }


    }
})();